// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c827157e","aiSupportButton":"a5673258","appearButton":"e612dd31"};